import { render, staticRenderFns } from "./picture-card.vue?vue&type=template&id=3e89121c"
import script from "./picture-card.vue?vue&type=script&lang=js"
export * from "./picture-card.vue?vue&type=script&lang=js"
import style0 from "./picture-card.vue?vue&type=style&index=0&id=3e89121c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports